export const SCROLL_INDICATION = `גללו ימינה על מנת לצפות בכל הנתונים`